import { EstimateRow} from "../state/estimateRow";
import Api, {SearchResultItem} from "./api";
import OidcManager from "./oidcManager";

export interface SaveRowCommand {
    id?: number;
    baseRowId?: number;
    estimateId: number;    
}

export interface SaveTextRowCommand extends SaveRowCommand {
    text?: string;
}

export interface SaveCostRowCommand  extends SaveRowCommand {
    title?: string;
    description?: string;
    pasteTitle?: boolean;
    quantity?: number;
    unitOfMeasure?: string;
    craftCode?: string;
    hourlyWage?: number;
    manHours?: number;
    material?: number;
    labor?: number;
    equipment?: number;
    total?: number;
}

export interface SaveSubtotalRowCommand  extends SaveRowCommand {
    text?: string;
}

export interface ReorderRowsCommand {
    estimateId: number,
    sourceRowIds: number[],
    targetRowId: number,
}

export interface CloneRowsCommand {
    estimateId: number,
    idx: number[],
    baseRowId: number,
}

export interface HistoryCommand {
    estimateId: number,
}

export interface HistoryState {
    canUndo: boolean;
    canRedo: boolean;
}

export default class EstimateRowsApi extends Api {

    public constructor(oidc: OidcManager, address: string) {
        super(oidc, address)
    }

    load(command: { estimateId: number, skip: number, requireTotalCount: boolean }) : JQueryPromise<{data: EstimateRow[], totalCount: number}> {
        return super.get("/api/rows", command);
    }

    getRow(estimateId: number, rowId: number): JQueryPromise<{ data: EstimateRow[], totalCount: number }> {

        let command = this.loadOptionsToActionParams({
            filter: this.filterByKey("id", rowId)
        }, false);
        command.estimateId = estimateId;

        return super.get("/api/rows", command);
    }


    searchRowsByText(estimateId: number, options: DevExpress.data.LoadOptions) : JQueryPromise<{data: SearchResultItem[], totalCount: number}> {

        let command = this.loadOptionsToActionParams(options, false);
        command.estimateId = estimateId;
        
        return super.get("/api/rows/searchByText", command);
    }


    saveTextRow(command: SaveTextRowCommand): JQueryPromise<{id: number, history: HistoryState}>  {
        return super.post("/api/rows/text", command);
    }

    saveCostRow(command: SaveCostRowCommand): JQueryPromise<{id: number, history: HistoryState}>  {
        return super.post("/api/rows/cost", command);
    }

    saveSubtotalRow(command: SaveSubtotalRowCommand): JQueryPromise<{id: number, history: HistoryState}>  {
        return super.post("/api/rows/subtotal", command);
    }

    remove(command: {estimateId: number, idx: number[]; }): JQueryPromise<HistoryState>  {
        return super.delete("/api/rows", command);
    }
    
    reorder(command: ReorderRowsCommand): JQueryPromise<HistoryState>  {
        return super.post("/api/rows/reorder", command);
    }

    clone(command: CloneRowsCommand): JQueryPromise<{idx: number[], history: HistoryState}>  {
        return super.post("/api/rows/clone", command);
    }

    undo(command: HistoryCommand): JQueryPromise<HistoryState>  {
        return super.post("/api/rows/undo", command);
    }
    redo(command: HistoryCommand): JQueryPromise<HistoryState>  {
        return super.post("/api/rows/redo", command);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/api/estimate-rows.ts